<template>
  <div>
    <div v-if="singleBooking.actual_booking_check_in_date == null">
      <v-card flat>
        <!--{{singleBooking.booking_type_id}}-->
        <GateEntryTicket v-if="singleBooking.booking_type_id === 'FF9330A3' || singleBooking.booking_type_id === 'GB601X10'"
                         :booking="singleBooking"></GateEntryTicket>
        <TourOperatorBooking v-if="singleBooking.booking_type_id === 'PB001A20'"
                             :booking="singleBooking"></TourOperatorBooking>
        <GroupBooking v-if="singleBooking.booking_type_id === '8D7E6504' || singleBooking.booking_type_id === 'C3237489'"
                      :booking="singleBooking"></GroupBooking>
        <MemberBooking v-if="singleBooking.booking_type_id === '7769748C'"
                       :booking="singleBooking"></MemberBooking>
      </v-card>
    </div>
    <div v-else>
      This booking is already checked in and hence cannot be edited.
    </div>
  </div>
</template>

<script>
  import BookingVuex from '../../../mixins/Computed/Booking/BookingVuex'
  import GateEntryTicket from './Snippets/GateEntryTicket.vue'
  import TourOperatorBooking from './Snippets/TourOperatorBooking.vue'
  import GroupBooking from './Snippets/GroupBooking.vue'
  import MemberBooking from './Snippets/MemberBooking.vue'

  export default {
    components: {
      GateEntryTicket,
      TourOperatorBooking,
      GroupBooking,
      MemberBooking
    },
    name: 'edit-booking',
    data() {
      return {
        today: new Date().toISOString().split('T')[0] // Format as YYYY-MM-DD
      }
    },
    computed: {
      isFutureCheckIn() {
        if (!this.singleBooking.booking_check_in_date) return false;

        // Convert booking_check_in_date to YYYY-MM-DD format for comparison
        const checkInDate = new Date(this.singleBooking.booking_check_in_date);
        const checkInFormatted = checkInDate.toISOString().split('T')[0];

        return checkInFormatted > this.today;
      },
      formatCheckInDate() {
        if (!this.singleBooking.booking_check_in_date) return '';

        // Format the date for display
        const date = new Date(this.singleBooking.booking_check_in_date);
        return date.toLocaleDateString('en-US', {
          weekday: 'short',
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });
      }
    },
    created() {
      this.$store.dispatch('get_booking', this.$route.params.booking_id)
    },
    mixins: [BookingVuex]
  }
</script>

<style scoped>
</style>
